export default __webpack_public_path__ + "static/img/test_clothing_icon.ce299df.svg";